/** @module csi/widget/TimeTextBox */
define([
	"dojo/_base/declare",
	"dojo/keys",
	"dojo/query",
	"dijit/form/TimeTextBox",
	"./_DateTimeMixin",
	"./_ErrorMessageMixin"
], function(declare,keys,query,TimeTextBox,_DateTimeMixin,_ErrorMessageMixin) {

	return declare([TimeTextBox, _DateTimeMixin, _ErrorMessageMixin], {
		_popupClickEvent: "onClick",

		_textKeys: [
			keys.BACKSPACE,
			keys.DELETE,
			keys.END,
			keys.HOME,
			keys.SHIFT,
			keys.CTRL,
			keys.ALT,
			keys.META
		],

		onInput: function(/*Event*/e) {
			// summary: for TimeTextBox, only forward input events when drop down is closed
			if (!this._opened) {
				this.onTextBoxInput(e);
			}
		},

		openDropDown: function(/*Function*/callback) {
			// summary: scroll the time drop down to selected time
			this.inherited(arguments);

			// FIX: Should be addressed in upcoming Dojo release - https://github.com/dojo/dijit/pull/132/files
			var parentNode = this.dropDown.domNode.parentNode;
			var selectedNode = query(".dijitTimePickerItemSelected", this.dropDown.domNode);
			if (selectedNode[0]) {
				// center the selected node in the client area of the popup.
				parentNode.scrollTop = selectedNode[0].offsetTop - (parentNode.clientHeight / 2);
			} else {
				// there is no currently selected value. Position the list so that the median node is visible.
				parentNode.scrollTop = (parentNode.scrollHeight - parentNode.clientHeight) / 2;
			}
		},
		
		/**
		 * Set time value; overridden to support time value passed as a number
		 * @param {Date|number} value
		 * @param {boolean} [priorityChange]
		 * @param {string} [formattedValue]
		 */
		_setValueAttr: function(value, priorityChange, formattedValue) {
			this.inherited(arguments, [this.normalizeValue(value), priorityChange, formattedValue]);
		}
	});
});